import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-105725a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "tw-absolute tw-top-2 tw-left-2" }
const _hoisted_3 = { class: "task-header" }
const _hoisted_4 = {
  key: 0,
  class: "tw-mt-[50px]"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tw-underline" }, "       ", -1))
const _hoisted_6 = { class: "tw-absolute tw-w-full tw-text-center tw-bottom-[20px] tw-left-0" }
const _hoisted_7 = {
  key: 0,
  class: "tw-inline-block tw-mx-[20px]"
}
const _hoisted_8 = { class: "tw-inline-block tw-ml-[5px]" }
const _hoisted_9 = { class: "tw-inline-block tw-mx-[20px]" }
const _hoisted_10 = { class: "tw-inline-block tw-ml-[5px]" }
const _hoisted_11 = { class: "tw-absolute tw-bottom-[10px] tw-right-[10px]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TaskA = _resolveComponent("TaskA")!
  const _component_TaskB = _resolveComponent("TaskB")!
  const _component_TaskC = _resolveComponent("TaskC")!
  const _component_TaskD = _resolveComponent("TaskD")!
  const _component_SpeakerSvg = _resolveComponent("SpeakerSvg")!

  return (!_ctx.isCompleted)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, "S.P. " + _toDisplayString(_ctx.spellingPoints), 1),
        _createElementVNode("div", _hoisted_3, [
          (_ctx.sentenceValue)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createTextVNode(_toDisplayString(_ctx.sentenceValue[0]) + " ", 1),
                _hoisted_5,
                _createTextVNode(" " + _toDisplayString(_ctx.sentenceValue[1]), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.task == 1)
          ? (_openBlock(), _createBlock(_component_TaskA, {
              key: 0,
              onSuccess: _cache[0] || (_cache[0] = ($event: any) => (_ctx.task = 2))
            }))
          : (_ctx.task == 2)
            ? (_openBlock(), _createBlock(_component_TaskB, {
                key: 1,
                onSuccess: _cache[1] || (_cache[1] = ($event: any) => (_ctx.task = 3))
              }))
            : (_ctx.task == 3)
              ? (_openBlock(), _createBlock(_component_TaskC, {
                  key: 2,
                  onSuccess: _cache[2] || (_cache[2] = ($event: any) => (_ctx.task = 4))
                }))
              : (_ctx.task == 4)
                ? (_openBlock(), _createBlock(_component_TaskD, {
                    key: 3,
                    onCompleted: _ctx.nextWord,
                    onTryagain: _cache[3] || (_cache[3] = ($event: any) => (_ctx.task = 1))
                  }, null, 8, ["onCompleted"]))
                : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.sentence?.audio_file)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("a", {
                  href: "",
                  onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.playSentenceAudio && _ctx.playSentenceAudio(...args)), ["prevent"])),
                  class: "speaker tw-text-primary"
                }, [
                  _createTextVNode(" Sentence "),
                  _createElementVNode("span", _hoisted_8, [
                    _createVNode(_component_SpeakerSvg)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("a", {
              href: "",
              onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.playWordAudio && _ctx.playWordAudio(...args)), ["prevent"])),
              class: "speaker tw-text-primary"
            }, [
              _createTextVNode(" Word "),
              _createElementVNode("span", _hoisted_10, [
                _createVNode(_component_SpeakerSvg)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.progress), 1)
      ]))
    : _createCommentVNode("", true)
}